import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
};

const plantsSlice = createSlice({
  name: "plants",
  initialState,
  reducers: {
    fetchPlantsStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    fetchPlantsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchPlantsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const {
  fetchPlantsStart,
  fetchPlantsSuccess,
  fetchPlantsFailure,
} = plantsSlice.actions;
export default plantsSlice.reducer;
